<template>
  <div class="release-form-main-page">
    <main-header :hasBanner="true"></main-header>
    <section class="main-center list-clr">
      <div class="r-title">房源发布操作步骤</div>
      <div class="step-box">
        <ul id="timeline">
          <li class="work">
            <input class="radio" id="work5" name="works" type="radio" checked />
            <div class="relative">
              <label for="work5">二手房买卖合同网签准备</label>
              <span class="date">步骤1</span>
              <span class="circle"></span>
            </div>
            <div class="content">
              <p></p>
              <p>
                ① 卖方个人申请完成房源挂牌。<a> &nbsp;&nbsp;&nbsp;&nbsp;</a>
              </p>
              <p>② 卖方授权委托房产经纪机构完成房源挂牌。</p>
              <p>
                <a style="color: #1890ff; cursor: pointer" @click="goRelease"
                  >前往发布</a
                >
              </p>
            </div>
          </li>

          <li class="work">
            <input class="radio" id="work4" name="works" type="radio" />
            <div class="relative">
              <label for="work4">二手房买卖合同网签</label>
              <span class="date">步骤2</span>
              <span class="circle"></span>
            </div>
            <div class="content">
              <p></p>
              <p>
                ①
                房产经纪机构录入二手房买卖合同并提交至房管部门合同审核窗口审核；
              </p>
              <p>
                ② 房管部门合同审核窗口审核房产经纪机构提交的二手房买卖合同；
              </p>
              <p>③ 房产经纪机构打印通过房管部门审核的二手房买卖合同。</p>
            </div>
          </li>

          <li class="work">
            <input class="radio" id="work3" name="works" type="radio" />
            <div class="relative">
              <label for="work3">监管资金入账</label>
              <span class="date">步骤3</span>
              <span class="circle"></span>
            </div>
            <div class="content">
              <p></p>
              <p>
                ①
                房产经纪机构和买卖双方共同到房管部门资金监管窗口签订资金监管协议；
              </p>
              <p>② 买方将监管资金存入指定的监管银行并取得存款凭证。</p>
            </div>
          </li>

          <li class="work">
            <input class="radio" id="work2" name="works" type="radio" />
            <div class="relative">
              <label for="work2">二手房买卖网签合同备案</label>
              <span class="date">步骤4</span>
              <span class="circle"></span>
            </div>
            <div class="content">
              <p></p>
              <p>
                房产经纪机构和买卖双方共同持二手房买卖网签合同、资金监管协议和存款凭证到房管部门合同审核窗口进行备案确认。
              </p>
            </div>
          </li>

          <li class="work">
            <input class="radio" id="work1" name="works" type="radio" />
            <div class="relative">
              <label for="work1">监管资金出账</label>
              <span class="date">步骤5</span>
              <span class="circle"></span>
            </div>
            <div class="content">
              <p></p>
              <p>
                买方领取不动产权证书后，卖方持不动产权证书复印件、资金监管协议原件及卖方身份证原件到房管部门资金监管窗口申请领取监管资金。
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import { resourcesDetail } from "@/assets/api/resources";
export default {
  name: "Release",
  components: {
    mainHeader,
    mainFooter,
  },

  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    goRelease() {
      this.$router.push("/resources/form");
    },
  },
};
</script>

<style lang="less">
.release-form-main-page {
  background: #fff;
  .r-title {
    font-size: 26px;
    padding-bottom: 20px;
    margin-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
  .list-clr {
    padding: 10px 0 42px;

    .mg-t20 {
      margin-top: 20px;
    }
    #mapBox {
      width: 100%;
      height: 500px;
    }
  }

  .step-box {
    width: 1200px;
    margin: 0 auto;

    #timeline {
      list-style: none;
      margin: 50px 0 30px 180px;
      padding-left: 32px;
      border-left: 3px solid #eee9dc;
    }
    #timeline li {
      margin: 40px 0;
      position: relative;
    }
    #timeline p {
      margin: 0 0 15px;
    }

    .date {
      margin-top: -10px;
      top: 50%;
      left: -138px;
      font-size: 0.95em;
      line-height: 20px;
      position: absolute;
    }

    .content {
      max-height: 20px;
      padding: 50px 20px 0;
      border-color: transparent;
      border-width: 1px;
      border-style: solid;
      border-radius: 0.5em;
      position: relative;
    }
    .content:before,
    .content:after {
      content: "";
      width: 0;
      height: 0;
      border: solid transparent;
      position: absolute;
      pointer-events: none;
      right: 100%;
    }
    .content:before {
      border-right-color: inherit;
      border-width: 20px;
      top: 50%;
      margin-top: -20px;
    }
    .content:after {
      border-width: 18px;
      top: 50%;
      margin-top: -18px;
    }
    .content p {
      max-height: 0;
      color: transparent;
      text-align: justify;
      text-indent: 2em;
      word-break: break-word;
      hyphens: auto;
      overflow: hidden;
    }

    .content p img {
      height: 60px;
      text-align: center;
      width: 70px;
      float: right;
    }

    label {
      font-size: 1.3em;
      position: absolute;
      z-index: 100;
      cursor: pointer;
      top: 20px;
      transition: transform 0.2s linear;
    }

    .radio {
      display: none;
    }

    .radio:checked + .relative label {
      cursor: auto;
      transform: translateX(42px);
    }
    .radio:checked + .relative .circle {
      background: #b1191a;
    }
    .radio:checked ~ .content {
      max-height: 340px;
      border-color: #b1191a;
      margin-right: -10px;
      transform: translateX(20px);
      transition: max-height 0.4s linear, border-color 0.5s linear,
        transform 0.2s linear;
    }
    .radio:checked ~ .content p {
      max-height: 200px;
      color: #9c9fa1;
      transition: color 0.3s linear 0.3s;
    }

    .circle {
      margin-top: -10px;
      top: 50%;
      left: -44px;
      width: 10px;
      height: 10px;
      background: #f98262;
      border: 5px solid #eee9dc;
      border-radius: 50%;
      display: block;
      position: absolute;
      box-sizing: content-box;
    }

    .content {
      max-height: 20px;
      padding: 50px 20px 0;
      border-color: transparent;
      border-width: 1px;
      border-style: solid;
      border-radius: 0.5em;
      position: relative;
    }
    .content:before,
    .content:after {
      content: "";
      width: 0;
      height: 0;
      border: solid transparent;
      position: absolute;
      pointer-events: none;
      right: 100%;
    }
    .content:before {
      border-right-color: inherit;
      border-width: 20px;
      top: 50%;
      margin-top: -20px;
    }
    .content:after {
      border-width: 18px;
      top: 50%;
      margin-top: -18px;
    }
    .content p {
      max-height: 0;
      color: transparent;
      text-align: justify;
      text-indent: 2em;
      word-break: break-word;
      hyphens: auto;
      overflow: hidden;
    }

    .content p img {
      height: 60px;
      text-align: center;
      width: 70px;
      float: right;
    }

    label {
      font-size: 1.3em;
      position: absolute;
      z-index: 100;
      cursor: pointer;
      top: 20px;
      transition: transform 0.2s linear;
    }

    .radio {
      display: none;
    }

    .radio:checked + .relative label {
      cursor: auto;
      transform: translateX(42px);
    }
    .radio:checked + .relative .circle {
      background: #b1191a;
    }
    .radio:checked ~ .content {
      max-height: 340px;
      border-color: #b1191a;
      margin-right: -10px;
      transform: translateX(20px);
      transition: max-height 0.4s linear, border-color 0.5s linear,
        transform 0.2s linear;
    }
    .radio:checked ~ .content p {
      max-height: 200px;
      color: #9c9fa1;
      transition: color 0.3s linear 0.3s;
    }

    label {
      font-size: 1.3em;
      position: absolute;
      z-index: 100;
      cursor: pointer;
      top: 20px;
      transition: transform 0.2s linear;
    }
  }
}
</style>